var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-wrapper mb-10"},[_c('CollectionDetailsPanel',[_vm._v(" :collection='mainCollection', > ")]),_c('site-footer',{staticClass:"mt-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }